import { useState } from 'react'
import { Box, Button } from '@mui/material'
import { ChevronDown20Regular, ChevronRight20Regular } from '@/components/Icon'
import styles from './CollapsibleNavSection.module.scss'



export default function CollapsibleNavSection({
  title,
  defaultExpanded = false,
  collapsible = true,
  titleClassName,
  children,
  showMoreLabel,
  onShowMore,
  headerActions,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded)

  const isExpanded = collapsible ? expanded : true
  const Chevron = isExpanded ? ChevronDown20Regular : ChevronRight20Regular

  return (
    <Box className={styles.section}>
      <Box className={styles.headerRow}>
        {collapsible ? (
          <Button
            type="button"
            variant="text"
            className={styles.headerToggle}
            onClick={() => setExpanded((value) => !value)}
            aria-expanded={isExpanded}
          >
            <Box
              component="span"
              className={[styles.title, titleClassName].filter(Boolean).join(' ')}
            >
              {title}
            </Box>
            <Box component="span" className={styles.chevron} aria-hidden>
              <Chevron />
            </Box>
          </Button>
        ) : (
          <Box className={`${styles.headerToggle} ${styles.headerStatic}`}>
            <Box
              component="span"
              className={[styles.title, titleClassName].filter(Boolean).join(' ')}
            >
              {title}
            </Box>
          </Box>
        )}
        {headerActions ? <Box className={styles.headerActions}>{headerActions}</Box> : null}
      </Box>
      {isExpanded ? (
        <Box className={styles.body}>
          {children}
          {showMoreLabel && onShowMore ? (
            <button type="button" className={styles.showMoreButton} onClick={onShowMore}>
              {showMoreLabel}
            </button>
          ) : null}
        </Box>
      ) : null}
    </Box>
  )
}
